export default __webpack_public_path__ + "static/media/pic1.8e176ab1.jpg";